import { render, staticRenderFns } from "./ChannelsComponent.vue?vue&type=template&id=4e8af762"
import script from "./ChannelsComponent.vue?vue&type=script&lang=js"
export * from "./ChannelsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports